/**
 * EVC Borrow Dialog Content Container
 *
 * Wrapped with withSuspense for loading states.
 */

import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { withSuspense } from '@/ui/utils/withSuspense'
import { type Address } from 'viem'
import { EvcBorrowDialogContent } from './EvcBorrowDialogContent'

interface EvcBorrowDialogContentContainerProps {
  closeDialog: () => void
  collateralVault: Address
  collateralSymbol: string
  collateralAmount: string
  collateralDecimals: number
  collateralAsset: Address
  collateralLogoURI?: string
  liabilityVault: Address
  liabilitySymbol: string
  borrowAmount: string
  liabilityDecimals: number
  liabilityAsset: Address
  liabilityLogoURI?: string
  subAccountId?: number
  wrapCollateralFromNative?: boolean
  unwrapBorrowToNative?: boolean
  /** Existing controller to disable before enabling new one (for controller switching) */
  existingController?: Address
  /** Whether we're modifying an existing position (affects dialog title) */
  isModifyingExistingPosition?: boolean
  /** List of collateral vaults already enabled for this position (to skip redundant enableCollateral calls) */
  enabledCollaterals?: Address[]
}

function EvcBorrowDialogContentContainerRaw(props: EvcBorrowDialogContentContainerProps) {
  return <EvcBorrowDialogContent {...props} />
}

const EvcBorrowDialogContentContainerWithSuspense = withSuspense(
  EvcBorrowDialogContentContainerRaw,
  DialogContentSkeleton,
)

export { EvcBorrowDialogContentContainerWithSuspense as EvcBorrowDialogContentContainer }
